import { Button, Modal, ScrollArea } from '@mantine/core'
import styles from './ClairChat.module.css'
import { Session, useChatHistoryInfinite } from './api'
import { Typography } from '../common/typography'

export default function ChatHistory({
  opened,
  close,
  activeSession,
  handleResumeSession,
}: {
  opened: boolean
  close: () => void
  activeSession: string
  handleResumeSession: (selectedSessionId: string) => void
}) {
  const {
    data: chatHistoryInfinite,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useChatHistoryInfinite(opened)

  const chatHistory =
    chatHistoryInfinite?.pages.flatMap((page) => page.data) ?? []

  return (
    <Modal.Root
      opened={opened}
      onClose={close}
      centered
      classNames={{
        header: styles.chatsModalHeader,
        body: styles.chatsModalBody,
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>
            <Typography fw={500} lh="125">
              Chats
            </Typography>
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          {chatHistory.length > 0 ? (
            <ScrollArea.Autosize mah={490}>
              {chatHistory.map((ch: Session) => (
                <div
                  key={ch.session_id}
                  className={styles.chatRow}
                  data-active={ch.session_id === activeSession}
                  onClick={() => handleResumeSession(ch.session_id)}
                >
                  <Typography lh="150">
                    {ch.title.length > 50
                      ? `${ch.title.substring(0, 50)}...`
                      : ch.title}
                  </Typography>
                </div>
              ))}
            </ScrollArea.Autosize>
          ) : (
            <Typography
              fc={{ light: 'primary-5', dark: 'primary-4' }}
              fw={500}
              ta="center"
            >
              No chat history found.
            </Typography>
          )}
          {chatHistory.length > 0 && (
            <Button
              classNames={{
                root: styles.buttonTransparent,
              }}
              disabled={!hasNextPage}
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
            >
              <Typography
                fc={{ light: 'primary-5', dark: 'primary-4' }}
                fw={500}
                lh="125"
              >
                Show more
              </Typography>
            </Button>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
